import React from 'react'
import Header from '../component/Header/Header'
import Footer from '../component/Footer/Footer'
import NewsListNew from '../component/NewsListNew/NewsListNew'
import HomeHero from '../component/HomeHero/HomeHero'
import { Helmet } from 'react-helmet'

function ArticleMain() {
  return (
    <div>
      <Helmet>
        <title>
        Health & Wellness Articles | Expert Insights from The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/article-main"
        />
        <meta
          name="description"
          content="Read expert healthcare articles on preventive medicine, stress, women’s health, and executive wellness at The Toronto Clinic."
        ></meta>
      </Helmet>
        <Header/>
        <HomeHero
            // heading='Articles'
            heading='Health Articles'
            content=''
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            textCenter={true}
            fullWidth={true}
            btn={false}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
        />
        <NewsListNew/>

        <div className='bottom-gradient-simple'>
          

          <Footer
          newsletterSection={false}
          />
          </div>
    </div>
  )
}

export default ArticleMain